export const hrvatski = {
  id: 'hr',
  jezik: 'Hrvatski',
  idJezik: 'Hr',
  krunice: [
    {
      value: 'gospa',
      label: 'Gospina krunica',
      pozdrav: 'Hvaljen Isus i Marija!',
      vjera: 'Isus, koji neka nam umnoži vjeru.',
      ufanje: 'Isus, koji neka nam učvrsti ufanje.',
      ljubav: 'Isus, koji neka nam usavrši ljubav.',
    },
    {
      value: 'rita',
      label: 'Krunica sv. Rite',
      pozdrav: 'Sveta Rito, zaštitnice nemogućih slučajeva, moli za nas.',
      vjera: 'Isus, koji neka nam po zagovoru svete Rite umnoži vjeru!',
      ufanje: 'Isus, koji neka nam po zagovoru svete Rite učvrsti ufanje!',
      ljubav: 'Isus, koji neka nam po zagovoru svete Rite usavrši ljubav!',
      gospodinePohitPomognes: 'Gospodine, pohiti da mi pomogneš.',
      bozePriteciUpomoc: 'Bože, priteci mi u pomoć.',
      otajstvo1:
        'Sveta Rito, Ti sad u nebu uživaš najveća dobra, ljubiteljica si patnje i trpljenja. Zbog našeg Gospodina Isusa Krista molim Te pomozi i meni da i ja po Tvojem zagovoru mogu sve svoje patnje i trpljenje podnijeti s ljubavlju za našega Gospodina Isusa Krista.',
      otajstvo2:
        'Sveta Rito, Ti si slijedila zapovjedi Isusa Krista i oprostila ubojici, a sinove poticala na oproštenje, molim Te, premila zagovornice i pomoćnice, pomozi i meni da i ja mogu oprostiti i srcem i dušom.',
      otajstvo3:
        'Sveta Rito, Ti si ostala udovica i prihvatila sveti samostan u kojem je slatki zakon posvećenja, pomozi i meni , mila svetice, da i ja svakim danom sve više i više duhom rastem i živim na slavu Isusovu.',
      otajstvo4:
        'Sveta Rito, Ti si u svom utočištu tijelo stezala lancima, postom i patnjom za ljubav Gospodina Isusa Krista, molim te pomozi i meni da i ja mogu činiti pokoru, obuzdati svoje strasti, živjeti i svjedočiti ljubav Isusovu.',
      otajstvo5:
        'Sveta Rito, onaj krvavi trn koji je probo tvoje čelo za Tebe je nebeski izvor koji ublažava tvoju bol i nagrada za strpljivost koju si toliko puta pokazala u svojim životnim situacijama u naglosti i srditosti svoga muža, pomozi i meni da i ja imam potrebnu strpljivost za svoga života.',
      opis: 'Na čelu je zadobila ranu koja ju je podsjećala na Isusovu trnovu krunu. Narod ju je odmah nakon smrti počeo štovati kao sveticu. Zaštitnica je bespomoćnih i beznadnih slučajeva',
    },
    {
      value: 'blazenogOca',
      label: 'Molitva blaženog oca',
      ref1: 'Oče, stavljam se u tvoje ruke, čini sa mnom po svojoj volji ma kakva ona bila, zahvaljujem ti.',
      ref2: 'Spreman sam na sve, prihvaćam sve, samo da se u meni i u svim stvorenjima vrši tvoja volja.',
      ref3: 'Ne želim ništa drugo, Oče. Predajem ti svoju dušu, predajem ti je sa svom ljubavi koju imam, jer te ljubim',
      ref4: 'i osjećam potrebu da se darujem tebi, da se predam u tvoje ruke bez granica, bez mjere, s jednim bezgraničnim pouzdanjem, jer si ti moj Otac.',
    },
    {
      value: 'gertruda',
      label: 'Krunica sv. Gertrude',
      pozdrav: 'Sveta Gertrudo, moli za nas.',
      vjera: 'Isus.',
      ufanje: 'Isus.',
      ljubav: 'Isus.',
      vjecniOce:
        'Vječni Oče, prikazujem Ti predragocjenu Krv Tvojega božanskoga Sina Isusa Krista, zajedno sa svim svetim misama koje se danas slave po čitavom svijetu, za duše u čistilištu, za grešnike u Crkvi, za grešnike u mojoj kući i u mojoj obitelji te za svu nerođenu djecu.',
      presvetoSrceIsusovo:
        'Presveto Srce Isusovo, otvori srca i um grješnika za istinu i svjetlo Božje. Bezgrješno Srce Marijino, moli za obraćenje grešnika i za cijeli svijet.',
      opisObecanjaIsusa:
        'Isus je obećao sv. Gertrudi da će svaki put kada se izmoli ova molitva pa i ako se izmoli više puta dnevno osloboditi tisuću duša iz čistilišta. U ovoj krunici ta se molitva moli pedeset puta. Ako se ova krunica izmoli samo jedanput, Isus će osloboditi 50 000 duša iz čistilišta. Sveta Gertruda mnogo je molila za siromašne duše u čistilištu. Misama, pokorom i dobrim djelima mnogim dušama je skratila čistilišne muke i otvorila im vrata nebeska. Dok bi svećenik na svetoj misi podizao hostiju, ona bi molila: Gospodine, Sveti Oče, prikazujem Ti svetu hostiju za sve one koji su na zemlji, u čistilištu i na Nebu U tome trenutku promatrala bi mnoge izbavljenike na prolazu iz čistilišnih muka u Nebo.',
    },
    {
      value: 'bozijeMilosrde',
      label: 'Krunica Božijeg Milosrđa',
      pozdrav: 'Isuse, uzdam se u Tebe!',
      vjera: 'Isus.',
      vjecniOce:
        'Vječni Oče, prikazujem ti tijelo i krv, dušu i božanstvo preljubljenoga Sina tvojega, Gospodina našega Isusa Krista, kao zadovoljštinu za grijehe naše i cijeloga svijeta.',
      pregorkaMuka:
        'Po njegovoj pregorkoj muci, budi milosrdan nama i cijelomu svijetu.',
      krajKrunice:
        'Sveti Bože, Sveti Jaki Bože, Sveti Besmrtni Bože, smiluj nam se i cijelome svijetu.',
      zakljucnaMolitvaKrvi:
        'O Krvi i Vodo što potekoste iz Srca Isusova kao izvor milosrđa za nas, uzdam se u tebe!',
      zakljucnaMolitvaMarijo: 'Marijo, Majko milosrđa, moli za nas!',
      zakljucnaMolitvaIsuse: 'Isuse, uzdam se u tebe!',
      zakljucnaMolitvaGospodine: 'Smiluj se nama i cijelomu svijetu, Gospodine',
      opis: 'Krunica Božanskog milosrđa je vjerska molitva i oblik pobožnosti koji temelji svoje uvjerenje na dobročinstvu i milosrđu koje Bog iskazuje prema svim ljudima. Njezin tekst potječe iz duhovnih iskustava svete Faustine Kowalske, redovnice iz Poljske koja je živjela u 20. stoljeću.',
      zaziv: 'Zazivi Božijem milosrđu',
    },
    {
      value: 'osobnaPredanje',
      label: 'Osobna molitva predanja',
    },
    {
      value: 'pobjede',
      label: 'Krunica Pobjede',
      vjera: 'Isus.',
      vjecniOce:
        'Vječni Oče, prikazujemo ti Predraagocjenu Krv Isusa Krista kao zadovoljštinu za svoje grijehe, na utjehu duša u čistilištu i za potrebe svete Crkve.',
      pobjedniceZlihDuhova:
        'Krvi Kristova, pobjednice zlih duhova – spasi nas!',
      jaganjcevaKrv:
        'Ali oni ga pobijediše krvlju Jaganjčevom – i riječju svoga Svjedočanstva.',
      hvaljen: 'Hvaljen i slavljen uvijek bio Isus,',
      otkupioKrvlju: 'Koji nas je otkupio svojom Krvlju!',
    },
    {
      value: 'andeoska',
      label: 'Anđeoska krunica',
      oceNas: 'Oče naš',
      zdravoMarije: '3x Zdravomarija',
      zaziv1Naslov: 'Prvi zaziv',
      zaziv1:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora Serafina, Gospodine, učini nas dostojne plamena goruće ljubavi.',
      uCast1Kora: '(u čast prvog anđeoskog kora)',
      zaziv2Naslov: 'Drugi zaziv',
      zaziv2:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora Kerubina, Gospodine, molimo te za milost da napustimo grješni put i da brzim korakom krenemo putem kršćanskog savršenstva.',
      uCast2Kora: '(u čast drugog anđeoskog kora)',
      zaziv3Naslov: 'Treći zaziv',
      zaziv3:
        'Zagovorom svetog Mihaela arkanđela i svetoga kora prijestolja, Gospodine, ulij u naša srca duh prave i iskrene poniznosti.',
      uCast3Kora: '(u čast trećeg anđeoskog kora)',
      zaziv4Naslov: 'Četvrti zaziv',
      zaziv4:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora gospodstva, Gospodine, daj nam milost da možemo upravljati svojim osjetilima i ispravljati neuredne strasti.',
      uCast4Kora: '(u čast četvrtog anđeoskog kora)',
      zaziv5Naslov: 'Peti zaziv',
      zaziv5:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora Vlasti, Gospodine, udostoji se zaštititi naše duše od zamki i napasti đavolskih.',
      uCast5Kora: '(u čast petog anđeoskog kora)',
      zaziv6Naslov: 'Šesti zaziv',
      zaziv6:
        'Zagovorom svetog Mihaela arkanđela i divljenja vrijedna kora nebeskih sila, Gospodine, ne dopusti da padnemo u napast, nego izbavi nas od zla.',
      uCast6Kora: '(u čast šestog anđeoskog kora)',
      zaziv7Naslov: 'Sedmi zaziv',
      zaziv7:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora vrhovništva, Gospodine, ispuni naše duše duhom prave i iskrene poslušnosti.',
      uCast7Kora: '(u čast sedmog anđeoskog kora)',
      zaziv8Naslov: 'Osmi zaziv',
      zaziv8:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora arkanđela, Gospodine, udijeli nam dar ustrajnosti u vjeri i dobrim djelima kako bismo stekli rajsku slavu.',
      uCast8Kora: '(u čast osmog anđeoskog kora)',
      zaziv9Naslov: 'Deveti zaziv',
      zaziv9:
        'Zagovorom svetog Mihaela arkanđela i nebeskog kora svih Anđela, Gospodine, molimo te da nas čuvaju u sadašnjem životu i da nas poslije uvedu u nebesku slavu.',
      uCast9Kora: '(u čast devetog anđeoskog kora)',
      uCast10Kora: 'u čast svetog Mihaela',
      uCast11Kora: 'u čast svetog Gabrijela',
      uCast12Kora: 'u čast svetog Rafaela',
      uCast13Kora: 'u čast anđela čuvara',
      slavniKneze:
        'Slavni kneže sveti Mihaele, vojskovođo nebeske vojske, čuvaru duša, pobjedniče nad pobunjenim duhovima, naš izvrsni vođo, poslije Isusa Krista, udostoj se osloboditi od svakoga zla nas koji se tebi s povjerenjem utječemo i molimo te da uz tvoju zaštitu svakoga dana vjerno služimo našemu Bogu.',
      moliZaNas:
        'Moli za nas, sveti Mihaele arkanđele, da dostojni postanemo obećanja Kristovih.',
      pomolimoSe:
        'Svemogući vječni Bože, koji si u svojoj čudesnoj dobroti i milosrđu za spasenje ljudi izabrao kneza svoje Crkve slavnog svetog Mihaela, molimo te za njegovu milosnu zaštitu kako bismo bili slobodni od svih naših duhovnih neprijatelja. U trenutku naše smrti ne prepusti nas starom neprijatelju, nego neka nas tvoj arkanđeo Mihael uvede u prisutnost tvojega božanskog veličanstva.',
    },
  ],
  daniTjedan: [
    { value: 'pon', label: 'Pon' },
    { value: 'uto', label: 'Uto' },
    { value: 'sri', label: 'Sri' },
    { value: 'cet', label: 'Čet' },
    { value: 'pet', label: 'Pet' },
    { value: 'sub', label: 'Sub' },
    { value: 'ned', label: 'Ned' },
  ],
  otajstvoSvjetla: 'Svijetla otajstva',
  otajstvoZalosno: 'Žalosna otajstva',
  otajstvoSlavno: 'Slavna otajstva',
  otajstvoRadosna: 'Radosna otajstva',
  uImeOcaSina: 'U ime Oca i Sina † i Duha Svetoga.',
  oceNas: 'Oče naš',
  isuse: 'Isuse',
  oceNasText:
    ', koji jesi na nebesima, sveti se ime Tvoje. Dođi kraljevstvo Tvoje. Budi volja Tvoja, kako na nebu tako i na zemlji. Kruh naš svagdanji daj nam danas. I otpusti nam duge naše, kako i mi otpuštamo dužnicima našim. I ne uvedi nas u napast, nego izbavi nas od zla.',
  amen: 'Amen.',
  slavaOcu:
    'Slava Ocu i Sinu † i Duhu Svetomu. Kako bijaše na početku, tako i sada i vazda i u vijeke vjekova.',
  zdravoMarijaPocetak:
    'Zdravo Marijo, milosti puna, Gospodin s tobom. Blagoslovljena ti među ženama i blagoslovljen plod utrobe tvoje,',
  zdravoMarijaKraj:
    'Sveta Marijo, Majko Božja, moli za nas grešnike, sada i na času smrti naše.',
  oMojIsuse:
    'O, moj Isuse, oprosti nam naše grijehe, očuvaj nas od paklenog ognja, dovedi u raj sve duše, osobito one, kojima je najpotrebnije tvoje milosrđe.',
  zdravoKraljice:
    'Zdravo Kraljice, Majko milosrđa, živote, slasti i ufanje naše, zdravo!\n K tebi vapijemo prognani sinovi Evini. \n K tebi uzdišemo tugujući i plačući u ovoj suznoj dolini. \n Svrni, dakle, Zagovornice naša one svoje milostive oči na nas te nam poslije ovoga progonstva pokaži Isusa, blagoslovljeni plod utrobe svoje. \n O blaga, o mila, o slatka Djevice Marijo.',
  apostolskoUvod:
    ', to je Tebi za ljubav, za obraćenje grješnika i kao naknada za uvrede koje se nanose Bezgrešnom Srcu Marijinu.',
  apostolskoVjerovanje: 'Apostolsko Vjerovanje',
  apostolskoVjerovanjeText:
    'Vjerujem u Boga, Oca svemogućega, Stvoritelja neba i zemlje. I u Isusa Krista, Sina njegova jedinoga, Gospodina našega, koji je začet po Duhu Svetom, rođen od Marije Djevice, mučen pod Poncijem Pilatom, raspet, umro i pokopan; sašao nad pakao; treći dan uskrsnuo od mrtvih; uzašao na nebesa, sjedi o desnu Boga Oca svemogućega; odonud će doći suditi žive i mrtve. Vjerujem u Duha Svetoga, svetu Crkvu katoličku, općinstvo svetih, oproštenje grijeha, uskrsnuće tijela, i život vječni.',
  naslov0: 'Gospina krunica †',
  naslov1: '1. zrnce',
  naslov2: '2. zrnce',
  naslov3: '3. zrnce',
  naslov4: '4. zrnce',
  naslov5: '5. zrnce',
  naslov6: 'Prvo otajstvo',
  naslov7: '1. zrnce - Prva desetica',
  naslov8: '2. zrnce - Prva desetica',
  naslov9: '3. zrnce  - Prva desetica',
  naslov10: '4. zrnce - Prva desetica',
  naslov11: '5. zrnce - Prva desetica',
  naslov12: '6. zrnce - Prva desetica',
  naslov13: '7. zrnce - Prva desetica',
  naslov14: '8. zrnce - Prva desetica',
  naslov15: '9. zrnce - Prva desetica',
  naslov16: '10. zrnce - Prva desetica',
  naslov17: 'Drugo otajstvo',
  naslov18: '1. zrnce - Druga desetica',
  naslov19: '2. zrnce - Druga desetica',
  naslov20: '3. zrnce - Druga desetica',
  naslov21: '4. zrnce - Druga desetica',
  naslov22: '5. zrnce - Druga desetica',
  naslov23: '6. zrnce - Druga desetica',
  naslov24: '7. zrnce - Druga desetica',
  naslov25: '8. zrnce - Druga desetica',
  naslov26: '9. zrnce - Druga desetica',
  naslov27: '10. zrnce - Druga desetica',
  naslov28: 'Treće otajstvo',
  naslov29: '1. zrnce - Treća desetica',
  naslov30: '2. zrnce - Treća desetica',
  naslov31: '3. zrnce - Treća desetica',
  naslov32: '4. zrnce - Treća desetica',
  naslov33: '5. zrnce - Treća desetica',
  naslov34: '6. zrnce - Treća desetica',
  naslov35: '7. zrnce - Treća desetica',
  naslov36: '8. zrnce - Treća desetica',
  naslov37: '9. zrnce - Treća desetica',
  naslov38: '10. zrnce - Treća desetica',
  naslov39: 'Četvrto otajstvo',
  naslov40: '1. zrnce - Četvrta desetica',
  naslov41: '2. zrnce - Četvrta desetica',
  naslov42: '3. zrnce - Četvrta desetica',
  naslov43: '4. zrnce - Četvrta desetica',
  naslov44: '5. zrnce - Četvrta desetica',
  naslov45: '6. zrnce - Četvrta desetica',
  naslov46: '7. zrnce - Četvrta desetica',
  naslov47: '8. zrnce - Četvrta desetica',
  naslov48: '9. zrnce - Četvrta desetica',
  naslov49: '10. zrnce - Četvrta desetica',
  naslov50: 'Peto otajstvo',
  naslov51: '1. zrnce - Peta desetica',
  naslov52: '2. zrnce - Peta desetica',
  naslov53: '3. zrnce - Peta desetica',
  naslov54: '4. zrnce - Peta desetica',
  naslov55: '5. zrnce - Peta desetica',
  naslov56: '6. zrnce - Peta desetica',
  naslov57: '7. zrnce - Peta desetica',
  naslov58: '8. zrnce - Peta desetica',
  naslov59: '9. zrnce - Peta desetica',
  naslov60: '10. zrnce - Peta desetica',
  naslov61: 'Završetak krunice',
  prvaDeseticaRita:
    'Isus, koji neka nam po zagovoru sv. Rite da strpljivost u teškim trenucima života.',
  drugaDeseticaRita:
    'Isus, koji neka nam po zagovoru svete Rite da snagu da opraštamo i ljubimo svoje neprijatelje.',
  trecaDeseticaRita:
    'Isus, koji neka nam po zagovoru svete Rite da potrebnu čistoću duše i tijela.',
  cetvrtaDeseticaRita:
    'Isus, koji neka nas po zagovoru svete Rite oslobodi od svakoga zla duše i tijela.',
  petaDeseticaRita:
    'Isus,  koji neka nas po zagovoru svete Rite oslobodi od svake naglosti i srditosti.',
  prvaDeseticaZalosna: 'Isus, koji se za nas krvlju znojio!',
  prvaDeseticaSlavna: 'Isus, koji je od mrtvih uskrsnuo!',
  prvaDeseticaRadosna: 'Isus, koga si Djevice, po Duhu Svetom začela!',
  prvaDeseticaSvjetla: 'Isus, koji je na rijeci Jordanu kršten bio!',
  drugaDeseticaZalosna: 'Isus, koji je za nas bičevan bio!',
  drugaDeseticaSlavna: 'Isus, koji je na nebo uzašao!',
  drugaDeseticaRadosna: 'Isus, koga si Djevice, Elizabeti u pohode nosila!',
  drugaDeseticaSvjetla: 'Isus, koji nam se na svadbi u Kani objavio!',
  trecaDeseticaZalosna: 'Isus, koji je za nas trnjem okrunjen bio!',
  trecaDeseticaSlavna: 'Isus, koji je Duha Svetog poslao!',
  trecaDeseticaRadosna: 'Isus, koga si Djevice, rodila!',
  trecaDeseticaSvjetla:
    'Isus, koji nam je Kraljevstvo Božje navijestio i na obraćenje pozvao!',
  cetvrtaDeseticaZalosna: 'Isus, koji je za nas teški križ nosio!',
  cetvrtaDeseticaSlavna: 'Isus, koji je Tebe Djevice, na nebo uzeo!',
  cetvrtaDeseticaRadosna: 'Isus, koga si Djevice, u hramu prikazala!',
  cetvrtaDeseticaSvjetla:
    'Isus, koji se na gori preobrazio i svoju nam slavu objavio!',
  petaDeseticaZalosna: 'Isus, koji je za nas raspet bio!',
  petaDeseticaSlavna: 'Isus, koji je Tebe Djevice, na nebu okrunio!',
  petaDeseticaRadosna: 'Isus, koga si Djevice, u hramu našla!',
  petaDeseticaSvjetla: 'Isus, koji nam se u otajstvu euharistije darovao!',
  krunicaKrozKorizma:
    '- tijekom korizmenog vremena i Vazmenog trodnevlja žalosna otajstva (od Pepelnice do uskrsnog bdijenja na Veliku subotu)',
  krunicaKrozBozic:
    '- tijekom božićnog vremena (od Badnjaka do blagdana Krštenja Gospodinova) radosna otajstva i otajstva svjetla',
  krunicaKrozUskrs:
    '- tijekom uskrsnog vremena (od uskrsnog bdijenja na Veliku subotu do svetkovine Duhova) slavna otajstva i otajstva svjetla',
  litanijeBozanskogMilosrdja: [
    { tekst: 'Gospodine, smiluj se!', odgovor: '' },
    { tekst: 'Kriste, smiluj se!', odgovor: '' },
    { tekst: 'Gospodine, smiluj se!', odgovor: '' },
    { tekst: 'Kriste, čuj nas!', odgovor: '' },
    { tekst: 'Kriste, usliši nas!', odgovor: '' },
    { tekst: 'Oče nebeski, Bože, smiluj nam se!', odgovor: '' },
    { tekst: 'Sine, Otkupitelju svijeta, Bože, smiluj nam se!', odgovor: '' },
    { tekst: 'Duše Sveti, Bože, smiluj nam se!', odgovor: '' },
    { tekst: 'Sveto Trojstvo, jedan Bože, smiluj nam se!', odgovor: '' },
    {
      tekst: 'Milosrđe Božje, ti neshvatljiva tajno Presvetoga Trojstva',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, ti izrazu Njegove najveće moći',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje si se objavilo u stvaranju nebeskih duhova',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje nas iz ništavila pozvalo u život',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje obuhvaćaš čitav svijet',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje nam daruješ besmrtan život',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje nas zaštićuješ od zasluženih kazna',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje nas oslobađaš od bijede grijeha',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst:
        'Milosrđe Božje, koje nam u Riječi što je Tijelo postala daruješ opravdanje',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje se na nas izlijevaš iz rana Kristovih',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje nam izvireš iz Presvetoga Srca',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst:
        'Milosrđe Božje, koje si nam dalo Presvetu Djevicu za Majku milosrđa',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst:
        'Milosrđe Božje, vidljivo u ustanovljenju Crkve koja obuhvaća cijeli svijet',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst:
        'Milosrđe Božje, vidljivo u ustanovljenju i dijeljenju svetih sakramenata',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, neograničeno u sakramentu krštenja i pokore',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, neizmjerno u sakramentu oltara i svećeništva',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje si nas pozvalo k svetoj vjeri',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, u obraćenju grješnika',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje posvećuješ pravednike',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje usavršuješ svete',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, vrelo bolesnicima i patnicima',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, utjeho i blago svih onih koji su skršena srca',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, ufanje onih koji očajavaju',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje uvijek i svugdje pratiš sve ljude',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje nas ispunjaš milostima',
      odgovor: 'uzdam se u tebe!',
    },
    { tekst: 'Milosrđe Božje, mire umirućih', odgovor: 'uzdam se u tebe!' },
    {
      tekst: 'Milosrđe Božje, koje nas čuvaš od paklenoga ognja',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, koje olakšavaš patnje dušama u čistilištu',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, ti slasti i neizmjerna radosti sviju svetih',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, beskrajno u svim tajnama vjere',
      odgovor: 'uzdam se u tebe!',
    },
    {
      tekst: 'Milosrđe Božje, neiscrpivi izvore čudesa',
      odgovor: 'uzdam se u tebe!',
    },

    {
      tekst: 'Bog je milosrdan i pun samilosti, spor na srdžbu i pun dobrote.',
      odgovor: '',
    },
    { tekst: 'Zato ću dovijeka klicati milosrđu Božanskom.', odgovor: '' },

    {
      naslov: 'Pomolimo se:',
      tekst:
        'O, vječni Bože, čije je milosrđe neistraživo i čije je blago smilovanja neiscrpivo, milosno pogledaj na nas i umnoži u nama svoje milosrđe da u teškim trenutcima ne očajavamo i ne budemo obeshrabreni, nego da se predamo s velikim pouzdanjem u tvoju svetu volju, koja je sama ljubav i smilovanje! Po Gospodinu našemu Isusu Kristu, Kralju milosrđa, koji nam s tobom i Duhom Svetim iskazuje milosrđe u sve vijeke vjekova. Amen.',
      odgovor: '',
    },
  ],
  molitvaPredanja: [
    { tekst: 'Gospodine Isuse Kriste,', odgovor: '' },
    { tekst: 'dolazim pred Tebe ovakav kakav jesam.', odgovor: '' },
    { tekst: 'Žao mi je zbog mojih grijeha.', odgovor: '' },
    { tekst: 'Molim Te, oprosti mi!', odgovor: '' },
    { tekst: 'U Tvoje ime opraštam svima koji su', odgovor: '' },
    { tekst: 'učinili nešto protiv mene.', odgovor: '' },
    { tekst: 'Odričem se sotone i svih zlih sila njegovih.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Gospodine Isuse Kriste,', odgovor: '' },
    { tekst: 'ja se Tebi potpuno predajem.', odgovor: '' },
    { tekst: 'Predajem se potpuno u Tvoje ruke,', odgovor: '' },
    { tekst: 'u Tvoju svetu i milosrdnu volju.', odgovor: '' },
    { tekst: 'Predajem se iz ljubavi i', odgovor: '' },
    { tekst: 'u ljubavi Duha Svetoga – u snazi Duha Svetoga.', odgovor: '' },
    {
      tekst: 'Predajem se po Bezgrešnom Srcu Djevice Majke Marije,',
      odgovor: '',
    },
    { tekst: 'po Njezinim prečistim rukama i', odgovor: '' },
    { tekst: 'po Njezinom moćnom i milosrdnom zagovoru.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Milostivi i milosrdni Bože,', odgovor: '' },
    { tekst: 'vjerujem i uzdam se u Tebe.', odgovor: '' },
    { tekst: 'Sada Te zauvijek pozivam u svoj život,', odgovor: '' },
    { tekst: 'koji si mi dao kao najveći dar,', odgovor: '' },
    { tekst: 'da Ti služim zauvijek.', odgovor: '' },
    { tekst: 'Isuse, prihvaćam Te kao svoga Gospodara,', odgovor: '' },
    { tekst: 'Boga i Spasitelja.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Iscijeli me i ozdravi!', odgovor: '' },
    { tekst: 'Ozdravi moje tijelo, duh i dušu,', odgovor: '' },
    { tekst: 'pamet i razum, psihičke i fizičke bolesti.', odgovor: '' },
    { tekst: 'Isuse, izliječi moju savjest,', odgovor: '' },
    { tekst: 'rane moga srca, moju krv i moju narav.', odgovor: '' },
    { tekst: 'Isuse, otvaram Ti svoju nutrinu:', odgovor: '' },
    { tekst: 'uđi u svaku ranu u meni!', odgovor: '' },
    { tekst: 'Takni me, Isuse,', odgovor: '' },
    { tekst: 'svojom svetom desnom rukom i', odgovor: '' },
    { tekst: 'svojom milosrdnom ljubavi.', odgovor: '' },
    { tekst: 'Isuse, spasi me i', odgovor: '' },
    { tekst: 'ozdravi me jer sam Tvoj i', odgovor: '' },
    { tekst: 'hoću ostati sav Tvoj.', odgovor: '' },
    { tekst: 'Isuse, osposobi me', odgovor: '' },
    { tekst: 'da Te upoznam i da Ti služim zauvijek.', odgovor: '' },
    { tekst: 'Učini me vjernim u služenju samo Tebi.', odgovor: '' },
    { tekst: 'Ja Ti se darujem i posvećujem.', odgovor: '' },
    { tekst: 'Isuse, molim Tvoje smilovanje:', odgovor: '' },
    { tekst: 'daruj mi duhovni vid i posluh.', odgovor: '' },
    { tekst: 'Preobrazi mi i ojačaj mi tijelo,', odgovor: '' },
    { tekst: 'duh, dušu i srce.', odgovor: '' },
    { tekst: 'Dođi, Gospodine Isuse, i', odgovor: '' },
    { tekst: 'zaštiti me svojom predragocjenom Krvlju', odgovor: '' },
    { tekst: 'i ispuni me puninom radosti Duha Svetoga.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Vodi me, Isuse,', odgovor: '' },
    { tekst: 'svojom jakom rukom u Tvojoj istini i', odgovor: '' },
    { tekst: 'na Tvome putu.', odgovor: '' },
    { tekst: 'Isuse, ne ostavi me nikada', odgovor: '' },
    { tekst: 'bez svoje ljubavi i milosrđa.', odgovor: '' },
    { tekst: 'Isuse, Ti si moj Spasitelj i', odgovor: '' },
    { tekst: 'Otkupitelj i zato se prepuštam', odgovor: '' },
    { tekst: 'potpuno Tvojoj milosrdnoj volji i ljubavi.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Milosrdni Isuse, ja se uzdam u Tebe.', odgovor: '' },
    { tekst: 'Predajem Ti i posvećujem ovu molitvu', odgovor: '' },
    { tekst: 'iz ljubavi moga srca i u snazi Duha Svetoga.', odgovor: '' },
    { tekst: 'Darujem Ti svoj život zauvijek', odgovor: '' },
    { tekst: '– na oltaru Bezgrešnog Srca Djevice Majke Marije,', odgovor: '' },
    { tekst: '– u sigurno utočište Njezinog Bezgrešnog Srca.', odgovor: '' },
    { tekst: 'Kroz plamen Njezine majčinske ljubavi,', odgovor: '' },
    { tekst: 'preko Njezinih bezgrešnih ruku,', odgovor: '' },
    { tekst: 'stavljam svoje predanje', odgovor: '' },
    { tekst: 'kao buket cvijeće u Tvoje Srce, Isuse.', odgovor: '' },
    { tekst: '', odgovor: '', odlomak: true },
    { tekst: 'Tvojoj milosrdnoj ljubavi,', odgovor: '' },
    { tekst: 'u čast Tvoga božanskog Srca,', odgovor: '' },
    { tekst: 'na hvalu i slavu Presvetog Trojstva,', odgovor: '' },
    { tekst: 'za spas moje duše u vremenu i vječnosti,', odgovor: '' },
    { tekst: 'predajem sve što imam i što jesam.', odgovor: '' },
    { tekst: 'Amen.', odgovor: '' },
    { tekst: 'Aleluja, aleluja!', odgovor: '' },
  ],
  litanijeSvetogMihovila: [
    { tekst: 'Gospodine, smiluj se!', odgovor: '' },
    { tekst: 'Kriste, smiluj se!', odgovor: '' },
    { tekst: 'Gospodine, smiluj se!', odgovor: '' },
    { tekst: 'Kriste, čuj nas!', odgovor: '' },
    { tekst: 'Kriste, usliši nas!', odgovor: '' },
    { tekst: 'Oče nebeski, Bože,', odgovor: 'smiluj nam se!' },
    { tekst: 'Sine, Otkupitelju svijeta, Bože,', odgovor: 'smiluj nam se!' },
    { tekst: 'Duše Sveti, Bože,', odgovor: 'smiluj nam se!' },
    { tekst: 'Sveto Trojstvo, jedan Bože,', odgovor: 'smiluj nam se!' },
    { tekst: 'Sveta Marijo, Kraljice anđela', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele Arkanđele', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, kneže suda nebeskog', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, vođo i utjeho Izraelova',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, Povjereniče Presvetog Trojstva',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, čuvaru raja', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, kneže vojske nebeske', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, najsjajnija zvijezdo anđeoskog zbora',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, vjesniče božanske pravde',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, pun ljubavi za sve ljude',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, preponizni pred bogom', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, najposlušniji božanskim zapovijedima',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, nepobjedivi u borbi protiv hereze',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, pobjedniče u borbi protiv sila zla',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, pobjedniče nad Luciferom i pobunjenim anđelima',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, štovatelju utjelovljenje rijeći',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, svijetlo anđelima',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, sigurni vođo u opasnostima',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, širitelju slave', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, tješitelju obeshrabrenih',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, anđele mira', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, u našim bolestima', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, vođo lutajućih', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, potporo onih koji se nadaju',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, čuvaru crkvenog nauka',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, zaštitniče Katoličke Crkve',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, velikodušni širitelju božijeg milosrđa',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, utočište siromašnih', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, olakšanje potlačenih', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, svijetlo i nado umirućih',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, naša snago u borbama', odgovor: 'moli za nas!' },
    {
      tekst: 'Sveti Mihaele, naš branitelju protiv svake prljavštine',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, tješitelju duša u čistilištu',
      odgovor: 'moli za nas!',
    },
    {
      tekst: 'Sveti Mihaele, čašćen od Crkve i anđela',
      odgovor: 'moli za nas!',
    },
    { tekst: 'Sveti Mihaele, odvjetniče naš', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, čuvaru naših duša', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, čuvaru djevica', odgovor: 'moli za nas!' },
    { tekst: 'Sveti Mihaele, časti sviju svetih', odgovor: 'moli za nas!' },
    { tekst: 'Sveti anđeli i arkanđeli', odgovor: 'branite nas' },
    {
      tekst: 'Jaganjče Božji, koji oduzimaš grijehe svijeta,',
      odgovor: 'oprosti nam Gospodine!',
    },
    {
      tekst: 'Jaganjče Božji, koji oduzimaš grijehe svijeta,',
      odgovor: 'usliši nas Gospodine!',
    },
    {
      tekst: 'Jaganjče Božji, koji oduzimaš grijehe svijeta,',
      odgovor: 'smiluj nam se, Gospodine!',
    },
    { tekst: 'Moli za nas, sveti Mihaele Arkanđele!', odgovor: '' },
    { tekst: 'Da dostojni postanemo obećanja Kristovih.', odgovor: '' },
    { tekst: 'Pomolimo se:', odgovor: '' },
    {
      tekst:
        'Svemogući i vječni Bože, koji si nam dao svetoga Mihaela arkanđela za zaštitnika i branitelja, neka nas naše molitve sačuvaju od svakoga zla i vatre pakla. To te molimo po Kristu, Gospodinu našemu.',
      odgovor: 'Amen',
    },
  ],
};
